// L'id intero della sessione chat è una credenziale: a Sentry basta l'uuid per
// ritrovarla (stessa regola di backend/app/chat/session_signing.sessione_breve).
export function sessioneBreve(id: string | null | undefined): string | null {
  if (!id) return null;
  const parti = id.split("_");
  return parti.length === 9 ? parti[6] : id.slice(-12);
}
